import React from "react";
import { Icon } from "@iconify/react";

const Button = ({
  text,
  img,
  className,
  onClick,
  minHeight,
  maxHeight,
  minWidth,
  height,
  width,
  disabled,
  imgClass,
  loading = false,
  maxWidth,
  padding,
  imgright,
  clr,
  htmlType,
type

}) => {
  const buttonStyle = {
    minHeight: minHeight,
    maxHeight: maxHeight,
    minWidth: minWidth,
    maxWidth: maxWidth,
    height: height,
    width: width,
    padding: padding,
  };
  if (loading) {
    disabled = true;
  }
  return (
    <button
      className={`flex justify-center ${className}`}
      style={buttonStyle}
      onClick={onClick}
      disabled={disabled}
      htmlType={htmlType}
      type={type}
    >
      {loading ? (
        <>
          <span className="flex justify-center  items-center gap-2">
            {text}
            <img
              src="../../assets/icons/loading.svg"
              alt=""
              className="w-5 rotate-360 invert"
            />
          </span>
        </>
      ) : (
        <>
          {img && (
            <Icon
              icon={img}
              className="cursor-pointer"
              // color="#143A62"
              color={clr}
              width={18}
              height={18}
            />
          )}
          <span className="">{text}</span>
          {imgright && (
            <Icon
              icon={imgright}
              className="cursor-pointer"
              // color="#143A62"
              color={clr}
              width={20}
              height={20}
            />
          )}
        </>
      )}
    </button>
  );
};
export default Button;
